// app/frontend/components/ui/Forms/L2KCheckbox.tsx
import { Checkbox, CheckboxProps } from "@mantine/core";

export function L2KCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      radius="sm"
      styles={{
        label: {
          color: "#D0D0D0",
          fontFamily: "'Public Sans', sans-serif",
          fontSize: "14px",
        },
        input: {
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          borderColor: "rgba(255, 255, 255, 0.15)",
          "&:checked": {
            backgroundColor: "#FF9800",
            borderColor: "#FF9800",
          },
          "&:hover:not(:checked)": {
            borderColor: "rgba(255, 152, 0, 0.4)",
          },
        },
        icon: {
          color: "#171717",
        },
        error: {
          color: "#ff6b6b",
          fontFamily: "'Public Sans', sans-serif",
        },
        description: {
          color: "#B8B8B8",
          fontFamily: "'Public Sans', sans-serif",
        },
      }}
      {...props}
    />
  );
}

export default L2KCheckbox;
